import { API, API_POST } from "../../Config";

export const handleEdituser = (id, status) => {
  const f = new FormData();
  
  f.append("id", id);
  f.append("status", status);

  return API_POST(API.editUser, f);
};
